import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../../AutoFocus'
import LettersHintInput from './LettersHintInput'
import ImagePopup from '../ImagePopup'

import style from './style.css'
import sharedStyle from '../sharedStyle.css'

import replaceUnderscores from '../../../lib/replaceUnderscores'
import correctImg from 'Assets/check-green.svg'
import incorrectImg from 'Assets/x-icon-red.svg'

export default class FillInTheBlank extends Component {
  constructor(props){
    super(props);
    this.inputFormRef = React.createRef();
  }

  componentDidUpdate (prevProps) {
    if (this.refs.normalInput && prevProps.question.prompt !== this.props.question.prompt) {
      this.refs.normalInput.value = ''
    }
  }

  renderIncorrect () {
    return (
      <img
        src={incorrectImg}
        alt="Incorrect answer"
        className={style.incorrect}
      />
    )
  }

  renderCorrect () {
    return (
      <img
        src={correctImg}
        alt="Correct answer"
        className={style.correct}
      />
    )
  }

  onFormSubmit (event) {
    this.props.onSubmit(event)
    event.preventDefault()
  }

  componentDidMount() {
    this.inputFormRef.current.addEventListener('focusin', this.handleFocusIn);
  }

  componentWillUnmount() {
    this.inputFormRef.current.removeEventListener('focusin', this.handleFocusIn);
  }

  handleFocusIn = (event) => {
    const target = event.target;
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  render () {
    const question = this.props.question
    return (
      <div data-test-id="FillInTheBlank">
        <AutoFocus>
          <ImagePopup>
            <span className={classnames('sr-only', sharedStyle.selectPrompt)}>
              Please type the correct answer in the following input field,
              and then select the submit answer button or press the enter key when finished.
            </span>
          </ImagePopup>
        </AutoFocus>
        <form className={style.answerContainer} onSubmit={this.onFormSubmit.bind(this)} ref={this.inputFormRef}>
          {question.isComplete && !question.isCorrect
            ? null
            : (
              <label className={style.label}>
                <h2
                  className={sharedStyle.prompt}
                  dangerouslySetInnerHTML={{ __html: replaceUnderscores(question.prompt) }}
                  data-test-id="activityQuestion"
                  ref={(header) => { this.questionHeader = header }}
                />
                {Object.keys(question.hintConfig.letters).length
                  ? (
                    <LettersHintInput
                      hintConfig={question.hintConfig}
                      onAnswer={this.props.onAnswer}
                      isComplete={question.isComplete}
                      isCorrect={question.isCorrect}
                    />
                    )
                  : (
                    <div>
                      <input
                        type="text"
                        className={classnames(style.normalInput, { [style.completedInput]: this.props.question.isCorrect })}
                        ref="normalInput"
                        disabled={question.isComplete}
                        onChange={(event) => this.props.onAnswer(event.target.value)}
                        tabIndex="0"
                        data-test-id="fillInTheBlankAnswer"
                      />
                      {question.isAnswered && !question.isCorrect ? this.renderIncorrect() : null}
                      {question.isAnswered && question.isCorrect ? this.renderCorrect() : null}
                    </div>
                    )
                }

                {/* a hidden submit input is necessary for the onSubmit to trigger with multiple text inputs in a form */}
                <input type="submit" hidden />
              </label>
              )}
        </form>
      </div>
    )
  }
}

FillInTheBlank.propTypes = {
  onAnswer: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired, // allows submitting answer on Enter
  question: PropTypes.shape({
    prompt: PropTypes.string.isRequired,
    isComplete: PropTypes.bool,
    isAnswered: PropTypes.bool,
    isCorrect: PropTypes.bool,
    hintConfig: PropTypes.shape({
      wordsLength: PropTypes.arrayOf(
        PropTypes.number
      ).isRequired,
      letters: PropTypes.objectOf(
        PropTypes.string
      )
    }),
    inputAnswer: PropTypes.string
  })
}
